import React from "react";
import aboutImg from "../../assets/images/rivage.jpg";
import "../../styles/about.css";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();

  const aboutData = [
    {
      icon: "ri-wifi-line",
      title: "ABOUT_ITEM_1_TITLE",
      desc: "ABOUT_ITEM_1_DESC",
    },
    {
      icon: "ri-team-line",
      title: "ABOUT_ITEM_2_TITLE",
      desc: "ABOUT_ITEM_2_DESC",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "ABOUT_ITEM_3_TITLE",
      desc: "ABOUT_ITEM_3_DESC",
    },
  ];

  return (
    <section id="about">
      <div className="container">
        <div className="about-wrapper">
          <div className="about-content">
            <h6 className="subtitle">{t("ABOUT_TITLE_1")}</h6>
            <h2>{t("ABOUT_TITLE_2")}</h2>
            <h2 className="highlight">{t("ABOUT_TITLE_3")}</h2>
            <p className="description about-content-desc">{t("ABOUT_DESC")}</p>

            {aboutData.map((item, index) => (
              <div className="about-content-item" key={index}>
                <span className="about-item-icon">
                  <i className={item.icon}></i>
                </span>
                <div>
                  <h4 className="about-item-title">{t(item.title)}</h4>
                  <p className="description">{t(item.desc)}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="about-img">
            <img src={aboutImg} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
